/*jshint esversion: 6 */

const hamburgerMenu = document.getElementById("hamburgerMenu");
const mainContent = document.getElementById("main");
const offCanvasMenu = document.getElementById("off-canvas-menu");


function closeNav() {
    document.body.classList.remove("is-expanded");
}

function openNav() {
    document.body.classList.add("is-expanded");
}

function toggleNav() {
    if (document.body.classList.contains("is-expanded")) {
        closeNav();
    } else {
        openNav();
    }
}

hamburgerMenu.addEventListener("click", () => {
    toggleNav();
}, false);

mainContent.addEventListener("click", (e) => {
    // Close mobile nav if click away from nav
    if (e.target != offCanvasMenu || e.target == hamburgerMenu ) {
        closeNav();
    }
}, true);

document.addEventListener("keyup", (e) => {
    // Close mobile nav if 'esc' is pressed
    if (e.keyCode === 27) {
        closeNav();
    }
}, true);

const hamburgerHomepageMenu = document.getElementById("hamburgerHomepageMenu");
const mainHomepageContent = document.getElementById("main");
const offCanvasHomepageMenu = document.getElementById("off-canvas-homepage-menu");
const hamburgerCloseDesktop = document.getElementById("hamburgerMenu-close-desktop");

function closeHomepageNav() {
    document.body.classList.remove("is-expanded");
}

function openHomepageNav() {
    document.body.classList.add("is-expanded");
}

function toggleHomepageNav() {
    if (document.body.classList.contains("is-expanded")) {
        closeHomepageNav();
    } else {
        openHomepageNav();
    }
}

// if the hamburgerHomepageMenu exists, add event listener
if (hamburgerHomepageMenu) {
    hamburgerHomepageMenu.addEventListener("click", () => {
        toggleHomepageNav();
    }, false);
}

if (hamburgerCloseDesktop) {
    hamburgerCloseDesktop.addEventListener("click", () => {
        toggleHomepageNav();
    }, false);
}

if (mainHomepageContent)
{
    mainHomepageContent.addEventListener("click", (e) => {
        // Close mobile nav if click away from nav
        if (e.target != offCanvasMenu || e.target == hamburgerHomepageMenu) {
            closeHomepageNav();
        }
    }, true);
}

document.addEventListener("keyup", (e) => {
    // Close mobile nav if 'esc' is pressed
    if (e.keyCode === 27) {
        closeHomepageNav();
    }
}, true);


function adjustMenuWidth() {
    const viewportWidth = window.innerWidth;
    let menuWidth;
  
    if (viewportWidth >= 1900) {
      menuWidth = Math.max(800, viewportWidth * 0.4); // Example: 30% of viewport width
    } else {
      // Adjust based on your media queries or leave as is for smaller screens
      menuWidth = viewportWidth > 1400 ? 800 : 460; // Fallback sizes for lg and below
     
    }

    const menuWidthNumeric = parseInt(menuWidth, 10); 
    const adjustedMenuWidth = menuWidthNumeric + 50; 
  
    const menuOffset = `-${adjustedMenuWidth}px`;
  
    document.documentElement.style.setProperty('--menu-width', `${menuWidth}px`);
    document.documentElement.style.setProperty('--menu-offset', menuOffset);
  } 
  
  window.addEventListener('load', adjustMenuWidth);
  window.addEventListener('resize', adjustMenuWidth);
  